<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="voucher-template-main-sidebar" position="left" lockedOpen="gt-md">
        <sign-up-action-list-sidebar></sign-up-action-list-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div class="h2 mb-24">{{'Action data'|translate}}</div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Name'|translate}}</mat-label>
                            <input matInput formControlName="name" required>
                            <mat-error>{{'Name is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Action key'|translate}}</mat-label>
                            <input matInput formControlName="actionKey" required>
                            <mat-error>{{'Action key is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Validity time'|translate}}</mat-label>
                            <input matInput formControlName="validityTime" required>
                            <mat-error>{{'Validity time is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-checkbox formControlName="isActive" fxFlex="100">
                            <mat-label>{{'Is active'|translate}}</mat-label>
                        </mat-checkbox>
                    </div>

                    <table class="table">
                        <thead>
                        <tr>
                            <th style="width: 80%;">{{'Service'|translate}}</th>
                            <th style="width: 10%;">{{'Quantity'|translate}}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr formArrayName="items" *ngFor="let line of items().controls; index as i">
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="service">
                                        <mat-option [value]="service.id" *ngFor="let service of availableServices">
                                            {{service.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td [formGroupName]="i">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="quantity">
                                </mat-form-field>
                            </td>
                            <td><button (click)="removeItem(i)" mat-raised-button color="warn">{{'Remove'|translate}}</button></td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td><button type="button" (click)="addItem()" mat-raised-button color="primary">{{'Add item'|translate}}</button></td>
                        </tr>
                        </tfoot>
                    </table>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>